module.exports = __webpack_public_path__ + "static/media/minus.234cd799.svg";